/**
 * Accessibility: pause and play controls for autoplaying video and
 * scrolling logos (WCAG 2.2.2). Respects prefers-reduced-motion.
 */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findVideo(button) {
    var node = button.parentElement;
    for (var i = 0; node && i < 4; i++) {
      var video = node.querySelector('video');
      if (video) return video;
      node = node.parentElement;
    }
    return null;
  }

  function findToggleForVideo(video) {
    var node = video.parentElement;
    for (var i = 0; node && i < 4; i++) {
      var button = node.querySelector('[data-a11y-pause="video"]');
      if (button) return button;
      node = node.parentElement;
    }
    return null;
  }

  function setState(button, paused) {
    var type = button.getAttribute('data-a11y-pause');
    if (type === 'marquee') {
      var marquee = button.closest('.scrolling-text');
      if (marquee) marquee.classList.toggle('is-paused', paused);
    } else {
      var video = findVideo(button);
      if (video) {
        if (paused) {
          video.pause();
        } else {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }
      }
    }
    button.setAttribute('data-paused', paused ? 'true' : 'false');
    button.setAttribute('aria-label', button.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
  }

  function init(root) {
    (root || document).querySelectorAll('[data-a11y-pause]').forEach(function (button) {
      if (button.dataset.a11yReady) return;
      button.dataset.a11yReady = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setState(button, button.getAttribute('data-paused') !== 'true');
      });
      if (reduceMotion) {
        setState(button, true);
      } else if (button.getAttribute('data-a11y-pause') === 'video') {
        var video = findVideo(button);
        if (video && !video.autoplay) setState(button, true);
      }
    });
  }

  // Keep a paused video paused if theme scripts or lazy loading start it again.
  document.addEventListener('play', function (event) {
    var video = event.target;
    if (!video || video.tagName !== 'VIDEO') return;
    var button = findToggleForVideo(video);
    if (button && button.getAttribute('data-paused') === 'true') video.pause();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
